import { render } from "./AIGCModel.vue?vue&type=template&id=b5556704&ts=true"
import script from "./AIGCModel.vue?vue&type=script&lang=ts"
export * from "./AIGCModel.vue?vue&type=script&lang=ts"

import "./AIGCModel.vue?vue&type=style&index=0&id=b5556704&lang=less"

import exportComponent from "/Users/jiangshanwen/workspace/website-3.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__